import { useTranslation } from "react-i18next";
import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { AutocompleteElement, TextFieldElement } from "react-hook-form-mui";
import useGetCountries from "src/welcomeNonGemi/data-access/useGetCountries";

type country = {
  value: string;
  title: string;
  d06_numeric_code: string;
};

const AddressInfo = () => {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  const { data: countries, isLoading: isLoadingCountries } = useGetCountries({
    enabled: open,
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 5, mt: 5 }}>
      <Box>
        <Typography variant="h6" fontWeight="500">
          {t("Στοιχεία Διεύθυνσης")}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          spacing={2}
          lg={8}
          rowSpacing={4}
          sx={{ justifyContent: { xs: "center", md: "flex-start" } }}
        >
          <Grid item xs="auto">
            <AutocompleteElement
              options={
                countries?.data?.countries.map(
                  (country: country) => country.value,
                ) ?? []
              }
              loading={isLoadingCountries}
              label={t("Χώρα")}
              name="n01_d06_code"
              autocompleteProps={{
                sx: { width: 300 },

                onOpen: () => {
                  setOpen(true);
                },
                onClose: () => {
                  setOpen(false);
                },
                getOptionLabel: (option) =>
                  countries?.data?.countries?.find(
                    (country: country) => option === country.value,
                  )?.title ?? "",
              }}
            />
          </Grid>
          <Grid item xs="auto">
            <TextFieldElement label={t("Πόλη")} name="n01_address_city" />
          </Grid>
          <Grid item xs="auto">
            <TextFieldElement label={t("Τ.Κ.")} name="n01_address_tk" />
          </Grid>
          <Grid item xs="auto">
            <TextFieldElement label={t("Οδός")} name="n01_address_street" />
          </Grid>
          <Grid item xs="auto">
            <TextFieldElement label={t("Αριθμός")} name="n01_address_number" />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AddressInfo;
